import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { REQUIRED_FORM_FIELD } from 'src/app/core/constants/messages-form-field-validator';
import { ClientHttpService } from 'src/app/core/services/client-http/client-http.service';
import { Endpoints } from 'src/app/core/services/client-http/endpoints';
import { Login } from 'src/app/core/services/client-http/models/responses/login.model';
import { KEY_TOKEN } from 'src/app/core/services/local-storage/local-storage.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { DocumentHelper } from 'src/app/helper/document.helper';
import criptografar from 'src/app/share/routines/criptografar';
import descriptografar from 'src/app/share/routines/descriptografar';
import { validarCNPJ } from 'src/app/share/validators/validar-cnpj';
import { AppState } from 'src/app/state/app-state';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent {
  public form: FormGroup;
  hidePassword: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private http: ClientHttpService,
    private router: Router,
    private localStorage: LocalStorageService,
    private store: Store<AppState>
  ) {
    this.form = this.formBuilder.group({
      organizacao: [null, [Validators.required, validarCNPJ()]],
      login: [null, [Validators.required]],
      senha: [null, [Validators.required]],
      remember: [false],
    });
  }

  ngOnInit() {
    if (localStorage.getItem('parameters_seminovos')) {
      const decryptedBody = JSON.parse(
        descriptografar(localStorage.getItem('parameters_seminovos'))
      );
      this.form.patchValue(decryptedBody);
    }

    if (localStorage.getItem('remember')) {
      if (localStorage.getItem('remember') == 's') {
        this.form.get('remember').setValue(true);
      }
    }
  }

  public getErrorMessageFormField(attribute: string): string {
    if (this.form.controls[attribute].hasError('required')) {
      return REQUIRED_FORM_FIELD;
    }

    return '';
  }

  public isValidCnpj() {
    const cnpj = this.form.getRawValue().cnpj;

    if (cnpj) {
      const isValid = DocumentHelper.isValidCnpj(cnpj);
    }
  }

  public submit(): void {
    if (!this.form.valid) {
      return;
    }

    const { organizacao, login, senha } = this.form.getRawValue();

    interface Body {
      organizacao: string;
      login: string;
      senha: string;
    }

    const body: Body = {
      organizacao: organizacao as string,
      login: login as string,
      senha: senha as string,
    };
    const encryptedBody: string = criptografar(body);

    if (this.form.get('remember').value == true) {
      localStorage.setItem('remember', 's');
      localStorage.setItem('parameters_seminovos', encryptedBody);
    } else {
      if (localStorage.getItem('parameters_seminovos')) {
        localStorage.removeItem('parameters_seminovos');
        localStorage.removeItem('remember');
      }
    }

    const token = {
      token: encryptedBody,
    };

    this.http
      .postAuth<Login>({ path: Endpoints.LOGIN, token })
      .subscribe((res) => {
        const token = res.token;

        localStorage.setItem('userId', res.userId);

        this.localStorage.setItem({
          key: KEY_TOKEN,
          value: JSON.stringify({
            token,
          }),
        });

        this.router.navigate(['home']);
      });
  }
  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
}
